URLSearchParams.prototype.getIgnoreCase = function (key) {
    const keys = Array.from(this.keys());

    const foundKey = keys.find((k) => k.toLowerCase() === key.toLowerCase());

    return foundKey ? this.get(foundKey) : undefined;
};
